import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import style from './style.css'
import iconStyle from 'Styles/icon.css'
import panelStyle from 'Styles/panel.css'

import caretUp from 'Assets/caret-up-list.png'
import caretDown from 'Assets/caret-down-list.png'
import completedCheck from 'Assets/complete-check-2x.png'
import xIcon from 'Assets/x-icon-aqua.svg'

import progressInProgress from 'Assets/progress-inprogress.svg'
import progressNotStarted from 'Assets/progress-not-started.svg'

export default class StudentList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      columns: {
        name: -1,
        questionsReceived: 0,
        completion: 0,
        score: 0
      }
    }
    if (this.props.students && this.props.students.length > 0) {
      const column = 'name'
      let sortValue = 0
      switch (this.state.columns[column]) {
        case 1:
          sortValue = 1
          break
        default:
          sortValue = -1
          break
      }
      this.props.students.sort(function (a, b) {
        if (a[column] > b[column]) {
          return sortValue
        }
        if (a[column] < b[column]) {
          return -(sortValue)
        }
        return 0
      })
    }
  }

  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
      event.preventDefault()
    }
  }

  onStudentClick (student) {
    // toggle selected student off if clicked student is same as previously selected student
    student = this.state.selectedStudent != null && this.state.selectedStudent.id === student.id ? null : student
    this.setState({ selectedStudent: student })
    this.props.onStudentSelected(student)
  }

  renderStudentList () {
    const filter = this.props.studentFilter.toLowerCase()
    return this.props.students
      .filter(student => student.firstName.toLowerCase().includes(filter) || student.lastName.toLowerCase().includes(filter))
      .map((student) => this.renderStudent(student))
  }

  sortStudentList (column) {
    let sortValue = 0
    switch (this.state.columns[column]) {
      case 1:
        sortValue = -1
        break
      default:
        sortValue = 1
        break
    }
    this.props.students.sort(function (a, b) {
      if (a[column] > b[column]) {
        return sortValue
      }
      if (a[column] < b[column]) {
        return -(sortValue)
      }
      return 0
    })
    this.renderStudentList()
    const newColumnStates = this.state.columns
    // reset all columns to clear sorting and caret display in render
    newColumnStates.name = 0
    newColumnStates.questionsReceived = 0
    newColumnStates.completion = 0
    newColumnStates.score = 0
    newColumnStates[column] = sortValue
    this.setState({
      selectedStudent: null,
      columns: newColumnStates
    })
    this.props.onStudentSelected(null)
  }

  renderCompletedCheckbox () {
    return (
      <img
        alt="Completed checkbox"
        data-test-id="completedCheckbox"
        className={classnames(iconStyle.medium, style.completedCheckboxImg)}
        src={completedCheck}
      />
    )
  }

  renderStudent (student) {
    const pctComplete = Math.round(100 * student.score / this.props.scoreTarget)
    const isSelected = this.props.selectedStudent != null && student.id === this.props.selectedStudent.id
    const progressInfo = (
      <div>
        {student.score >= this.props.scoreTarget ? this.renderCompletedCheckbox() : <img className={classnames(iconStyle.medium, style.completedCheckboxImg)} src={progressInProgress} alt="In progress" />}
      </div>
    )

    return (
      <tr
        className={classnames(panelStyle.base, { [style.selectedRow]: isSelected })}
        data-test-id="studentListRow"
        id={`student${student.index}`}
        key={student.id}
        onClick={() => this.onStudentClick(student)}
        onKeyDown={(event) => this.onKeyDown(event)}
        tabIndex="0"
      >
        <td
          data-test-id="studentListName"
          aria-label={`Student ${student.firstName} ${student.lastName}`}
          className={style.studentName}
        >
          {this.renderStudentName(student.firstName, student.lastName, isSelected)}
        </td>
        <td
          data-test-id="studentListQuestionsReceived"
          aria-label={student.questionsReceived + ' questions'}
          className={style.studentQuestions}
        >
          {student.questionsReceived === 0 ? '-' : student.questionsReceived}
        </td>
        <td
          data-test-id="studentListQuestionsCircle"
          aria-label={student.score + ' points ' + (isSelected ? 'selected' : 'unselected')}
          className={style.studentCompletionCircle}
        >
          {pctComplete === 0 ? <img className={classnames(iconStyle.medium, style.completedCheckboxImg)} src={progressNotStarted} data-test-id="notStarted" alt="Not started" /> : progressInfo}
        </td>
        <td
          data-test-id="studentListQuestionsScore"
          aria-label={student.score + ' points ' + (isSelected ? 'selected' : 'unselected')}
          className={style.studentCompletion}
        >
          {pctComplete === 0 ? '-' : <span className={style.score}>{student.score}</span>}
        </td>
      </tr>
    )
  }

  renderStudentName (firstName, lastName, isSelected) {
    let cssClass = ''
    let icon = ''
    if (isSelected) {
      cssClass = style.selectedStudent
      icon = <img aria-hidden="true" className={style.icon} src={xIcon} />
    }
    return (
      <div>
        {icon}
        <span className={cssClass}>{firstName}<span className={style.studentLastName}>{lastName}</span></span>
      </div>
    )
  }

  renderNoStudents () {
    return (
      <tr className={panelStyle.base}>
        <td colSpan="4" className={style.noStudents}>No students enrolled</td>
      </tr>
    )
  }

  render () {
    const hasStudents = this.props.students && this.props.students.length > 0
    const splitOverride = this.props.splitPane ? style.splitOverride : ''

    return (
      <div className={style.rosterTable}>
        <table className={classnames(panelStyle.small, style.studentTable, splitOverride)}>
          <thead className={classnames(panelStyle.base, style.studentList)}>
            <tr>
              <th
                className={classnames(style.studentNameHeader)}
                onClick={() => this.sortStudentList('name')}
              >
                Name
                {this.state.columns.name !== 0
                  ? (
                      this.state.columns.name === 1
                        ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt="sort ascending" />
                        : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt="sort descending" />
                    )
                  : null
                }
              </th>
              <th
                className={style.questionsHeader}
                onClick={() => this.sortStudentList('questionsReceived')}
              >
                Questions
                {this.state.columns.questionsReceived !== 0
                  ? (
                      this.state.columns.questionsReceived === 1
                        ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt="sort ascending" />
                        : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt="sort descending" />
                    )
                  : null
                }
              </th>
              <th
                className={style.studentCompletionHeader}
                onClick={() => this.sortStudentList('completion')}
              >
                Completion
                {this.state.columns.completion !== 0
                  ? (
                      this.state.columns.completion === 1
                        ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt="sort ascending" />
                        : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt="sort descending" />
                    )
                  : null
                }
              </th>
              <th
                className={style.studentCompletionHeader}
                onClick={() => this.sortStudentList('score')}
              >
                Points
                {this.state.columns.score !== 0
                  ? (
                      this.state.columns.score === 1
                        ? <img aria-hidden="true" className={style.headerCaret} src={caretUp} alt="sort ascending" />
                        : <img aria-hidden="true" className={style.headerCaret} src={caretDown} alt="sort descending" />
                    )
                  : null
                }
              </th>
            </tr>
          </thead>
          <tbody className={style.studentTableBody}>
            {hasStudents
              ? this.renderStudentList()
              : this.renderNoStudents()}
          </tbody>
        </table>
      </div>
    )
  }
}

StudentList.propTypes = {
  students: PropTypes.array.isRequired,
  scoreTarget: PropTypes.number.isRequired,
  studentFilter: PropTypes.string,
  onStudentSelected: PropTypes.func.isRequired,
  selectedStudent: PropTypes.object,
  splitPane: PropTypes.bool
}
